module.exports = __webpack_public_path__ + "img/discussion.261333ff.svg";